import { TNotificationConfig } from "../types";

export const NOTIFICATION_REGISTRY: Record<string, TNotificationConfig> = {};
